module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-02-en.e0cb73c6fc580f010100abcef4392dcb.png";